import { Component } from '@angular/core';

/**
 * Component responsible for handling server requests and displaying UI notifications when a version mismatch is detected.
 */
@Component({
	selector: 'crownx-server-connection-indicator',
	templateUrl: './server-connection-indicator.component.html',
	styleUrls: ['./server-connection-indicator.component.css']
})
export class ServerConnectionIndicatorComponent {
}
